/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    Input,
} from '@angular/core';

import { AuthMatchOperation } from 'generated-types';
import { L10nService } from '@vmw/ngx-vip';
import { AuthMatchGroupMembershipConfigItem }
    from 'ajs/modules/auth-settings/factories/auth-match-group-membership.config-item.factory';
import * as l10n from './auth-match-group-membership-readonly.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description AuthMatchGroupMembership match readonly component.
 *
 * @author Aravindh Nagarajan
 */
@Component({
    selector: 'auth-match-group-membership-readonly',
    templateUrl: './auth-match-group-membership-readonly.component.html',
})
export class AuthMatchGroupMembershipReadonlyComponent {
    /**
     * Binding for AuthMatchGroupMembership match.
     */
    @Input()
    public editable: AuthMatchGroupMembershipConfigItem;

    /**
     * For template usage.
     */
    public readonly l10nKeys = l10nKeys;

    /**
     * Map of AuthMatchOperation and its corresponding label.
     */
    private readonly matchCriteriaMap: Map<AuthMatchOperation, string>;

    constructor(private readonly l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);

        this.matchCriteriaMap = new Map<AuthMatchOperation, string>([
            [AuthMatchOperation.AUTH_MATCH_CONTAINS,
                this.l10nService.getMessage(l10nKeys.memberLabel)],
            [AuthMatchOperation.AUTH_MATCH_DOES_NOT_CONTAIN,
                this.l10nService.getMessage(l10nKeys.notMemberLabel)],
        ]);
    }

    /**
     * Getter for criteria.
     */
    public get matchCriteria(): string {
        const { criteria } = this.editable.config;

        return criteria ? this.matchCriteriaMap.get(criteria) :
            this.l10nService.getMessage(l10nKeys.anyLabel);
    }

    /**
     * Getter for groups.
     */
    public get groups(): string[] {
        return this.editable.config.groups;
    }

    /**
     * Used in *ngFor.
     */
    public trackByIndex(index: number): number {
        return index;
    }
}
